(function(){
  var VERSION='2.2.0',lastOpener=null;
  window.CocoRockQuickViewVersion=VERSION;

  function unlockPage(){
    if(!document.querySelector('.cr-qv[open]')&&!document.querySelector('[data-cr-home-quick]:not([hidden])'))document.documentElement.style.overflow='';
  }

  function restoreOpener(){
    if(lastOpener&&document.contains(lastOpener))lastOpener.focus();
    lastOpener=null;
  }

  function openDialog(id,opener){
    var dialog=document.getElementById(id);
    if(!dialog)return;
    lastOpener=opener||document.activeElement;
    if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
    document.documentElement.style.overflow='hidden';
    init(dialog);
    var close=dialog.querySelector('[data-cr-qv-close]');if(close)window.requestAnimationFrame(function(){close.focus()});
  }

  function closeDialog(dialog){
    if(!dialog)return;
    if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
    unlockPage();
    restoreOpener();
  }

  function galleryParts(node){
    var gallery=node&&node.closest?node.closest('[data-cr-qv-gallery]'):null;
    return gallery?{
      gallery:gallery,
      viewport:gallery.querySelector('[data-cr-qv-viewport]'),
      slides:[].slice.call(gallery.querySelectorAll('[data-cr-qv-slide]')),
      thumbs:[].slice.call(gallery.querySelectorAll('[data-cr-qv-thumb]')),
      prev:gallery.querySelector('[data-cr-qv-prev]'),
      next:gallery.querySelector('[data-cr-qv-next]')
    }:null;
  }

  function current(parts){
    if(!parts||!parts.viewport)return 0;
    var value=parseInt(parts.viewport.dataset.crGalleryIndex,10);
    return Number.isFinite(value)?value:0;
  }

  function setIndex(parts,index,focusThumb){
    if(!parts||!parts.slides.length)return;
    var length=parts.slides.length;
    index=((index%length)+length)%length;
    parts.viewport.dataset.crGalleryIndex=String(index);
    parts.slides.forEach(function(slide,i){
      var active=i===index;
      slide.hidden=!active;
      slide.classList.toggle('is-active',active);
      slide.setAttribute('aria-hidden',active?'false':'true');
      slide.style.transform='';
    });
    parts.thumbs.forEach(function(thumb,i){
      var active=i===index;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active&&focusThumb)thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
    if(parts.prev)parts.prev.disabled=length<2;
    if(parts.next)parts.next.disabled=length<2;
    [parts.slides[index],parts.slides[(index+1)%length]].forEach(function(slide,position){
      if(!slide)return;var media=slide.querySelector('img,video,model-viewer');if(!media){slide.classList.add('is-media-ready');return}
      if(position===0&&media.tagName==='IMG')media.loading='eager';
      function ready(){slide.classList.add('is-media-ready');if(position===0&&parts.viewport)parts.viewport.setAttribute('aria-busy','false')}
      var loaded=media.tagName==='IMG'?media.complete:(media.tagName==='VIDEO'?media.readyState>=2:media.loaded===true);
      if(position===0&&parts.viewport)parts.viewport.setAttribute('aria-busy',loaded?'false':'true');
      if(loaded)ready();else{media.addEventListener(media.tagName==='VIDEO'?'loadeddata':'load',ready,{once:true});media.addEventListener('error',ready,{once:true})}
      if(typeof media.decode==='function')media.decode().then(ready).catch(function(){});
    });
  }

  function normalizeUrl(value){
    if(!value)return'';
    try{var url=new URL(value,window.location.origin);return url.pathname.replace(/_[0-9]+x[0-9]*(?=\.[a-z]+$)/i,'')}catch(error){return value.split('?')[0]}
  }

  function goToMedia(scope,mediaId,imageUrl){
    var gallery=scope.querySelector('[data-cr-qv-gallery]');
    if(!gallery)return;
    var parts=galleryParts(gallery),wantedImage=normalizeUrl(imageUrl),index=-1;
    parts.slides.some(function(slide,i){
      var idMatch=mediaId&&slide.dataset.mediaId===mediaId;
      var imageMatch=wantedImage&&normalizeUrl(slide.dataset.imageUrl)===wantedImage;
      if(idMatch||imageMatch){index=i;return true}return false;
    });
    if(index>=0)setIndex(parts,index,true);
  }

  function init(scope){
    var dialogs=[];
    if(scope&&scope.matches&&scope.matches('[data-cr-qv]'))dialogs.push(scope);
    (scope||document).querySelectorAll('[data-cr-qv]').forEach(function(dialog){dialogs.push(dialog)});
    dialogs.forEach(function(dialog){if(dialog.dataset.crDialogReady)return;dialog.dataset.crDialogReady='true';dialog.addEventListener('close',function(){unlockPage();restoreOpener()})});
    (scope||document).querySelectorAll('[data-cr-qv-gallery]').forEach(function(gallery){
      var parts=galleryParts(gallery),active=parts.slides.findIndex(function(slide){return slide.classList.contains('is-active')});
      setIndex(parts,active>=0?active:0,false);
      gallery.dataset.crGalleryReady=VERSION;
    });
  }

  function onClick(event){
    var opener=event.target.closest('[data-cr-qv-open]');
    if(opener){event.preventDefault();openDialog(opener.getAttribute('data-cr-qv-open'),opener);return}
    var closer=event.target.closest('[data-cr-qv-close]');
    if(closer){closeDialog(closer.closest('[data-cr-qv]'));return}
    var thumb=event.target.closest('[data-cr-qv-thumb]');
    if(thumb){event.preventDefault();setIndex(galleryParts(thumb),parseInt(thumb.dataset.index,10)||0,true);return}
    var arrow=event.target.closest('[data-cr-qv-prev],[data-cr-qv-next]');
    if(arrow){event.preventDefault();var parts=galleryParts(arrow),delta=arrow.hasAttribute('data-cr-qv-next')?1:-1;setIndex(parts,current(parts)+delta,true);return}
    var variant=event.target.closest('[data-cr-qv-variant]');
    if(variant&&!variant.disabled){
      event.preventDefault();
      var dialog=variant.closest('[data-cr-qv]');
      dialog.querySelectorAll('[data-cr-qv-variant]').forEach(function(item){item.setAttribute('aria-pressed',item===variant?'true':'false')});
      var price=dialog.querySelector('[data-cr-qv-price]');
      if(price&&variant.dataset.priceMoney)price.textContent=variant.dataset.priceMoney;
      goToMedia(dialog,variant.dataset.mediaId,variant.dataset.imageUrl);
      return;
    }
    var backdrop=event.target.matches&&event.target.matches('[data-cr-qv]')?event.target:null;
    if(backdrop)closeDialog(backdrop);
  }

  function onPointerDown(event){
    var viewport=event.target.closest('[data-cr-qv-viewport]');
    if(!viewport||(event.pointerType==='mouse'&&event.button!==0))return;
    var parts=galleryParts(viewport);
    if(!parts||parts.slides.length<2)return;
    var startX=event.clientX,lastX=startX,moved=false,active=parts.slides[current(parts)];
    viewport.classList.add('is-dragging');
    if(viewport.setPointerCapture)viewport.setPointerCapture(event.pointerId);
    function move(moveEvent){
      lastX=moveEvent.clientX;
      var delta=lastX-startX;
      if(Math.abs(delta)>5)moved=true;
      if(active)active.style.transform='translateX('+delta+'px)';
    }
    function end(endEvent){
      viewport.removeEventListener('pointermove',move);
      viewport.removeEventListener('pointerup',end);
      viewport.removeEventListener('pointercancel',end);
      viewport.classList.remove('is-dragging');
      if(active)active.style.transform='';
      if(viewport.hasPointerCapture&&viewport.hasPointerCapture(endEvent.pointerId))viewport.releasePointerCapture(endEvent.pointerId);
      var delta=lastX-startX;
      if(Math.abs(delta)>38)setIndex(parts,current(parts)+(delta<0?1:-1),true);
      if(moved){viewport.dataset.crDragged='true';setTimeout(function(){delete viewport.dataset.crDragged},0)}
    }
    viewport.addEventListener('pointermove',move);
    viewport.addEventListener('pointerup',end);
    viewport.addEventListener('pointercancel',end);
  }

  function suppressDraggedClick(event){
    var viewport=event.target.closest&&event.target.closest('[data-cr-qv-viewport]');
    if(viewport&&viewport.dataset.crDragged){event.preventDefault();event.stopPropagation()}
  }

  if(window.CocoRockQuickViewClick)document.removeEventListener('click',window.CocoRockQuickViewClick);
  if(window.CocoRockQuickViewPointer)document.removeEventListener('pointerdown',window.CocoRockQuickViewPointer);
  if(window.CocoRockQuickViewDragged)document.removeEventListener('click',window.CocoRockQuickViewDragged,true);
  window.CocoRockQuickViewClick=onClick;
  window.CocoRockQuickViewPointer=onPointerDown;
  window.CocoRockQuickViewDragged=suppressDraggedClick;
  document.addEventListener('click',onClick);
  document.addEventListener('pointerdown',onPointerDown);
  document.addEventListener('click',suppressDraggedClick,true);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
})();
